export const dictionary = {
  fr: {
    order: {
      navTitle: "Commander des photos",
      site: "Site",
      eyebrow: "Galeries de galas",
      title: "Commander",
      title2: "tes photos.",
      intro: "Choisis ton pack, ton gala, ton combat, puis sélectionne tes photos. Aucun paiement en ligne — tu reçois un récapitulatif et Nono te recontacte pour finaliser.",
      stepPack: "Choisis ton pack",
      stepGala: "Choisis ton gala",
      stepFight: "Choisis ton combat",
      stepPhotos: "Sélectionne tes photos",
      stepFinal: "Retouches & finalisation",
      fights: (n) => `${n} combat${n > 1 ? "s" : ""}`,
      upcoming: "À venir",
      noFights: "Les combats de ce gala seront ajoutés prochainement. Reviens bientôt ou écris à contact@fight-lens.fr.",
      groups: { "Combats amateurs": "Combats amateurs", "Combats professionnels": "Combats professionnels" },
      photosCount: (n) => `${n} photos`,
      photosAvailable: "Photos disponibles",
      galleryPending: "Galerie en préparation",
      maxPhotos: (n) => `${n} photos maximum`,
      viewPhotos: "Voir les photos",
      externalInstructions: "Notez les numéros des photos souhaitées, puis revenez ici pour passer votre commande en précisant votre sélection.",
      noPhotos: "La galerie de ce combat est en cours de préparation. Tu peux quand même commander ton pack — Nono t'enverra la galerie complète par email pour faire ta sélection.",
      selected: (n, limit) => `${n}${limit !== null ? ` / ${limit}` : ""} photo${n > 1 ? "s" : ""} sélectionnée${n > 1 ? "s" : ""}`,
      limitReached: (pack, limit) => `Limite atteinte — le ${pack} autorise ${limit} photos maximum. Passe au pack supérieur pour en sélectionner plus.`,
      retouchToggle: "Ajouter une demande de retouche (sur devis)",
      retouchPlaceholder: "Décris précisément la retouche souhaitée (photos concernées, style, éléments à modifier…)",
      messageLabel: "Message libre (optionnel)",
      messagePlaceholder: "Demandes supplémentaires, précisions, délais…",
      nameLabel: "Ton nom",
      namePlaceholder: "Prénom Nom",
      emailLabel: "Ton email",
      emailPlaceholder: "exemple@mail.com",
      retouchNotice: "Les retouches et demandes spéciales allongent le délai de livraison. Le tarif de retouche vous sera communiqué par email avant le début du travail.",
      submit: "Envoyer ma commande",
      sending: "Envoi…",
      errGalaFight: "Choisis un gala et un combat.",
      errPack: "Choisis un pack.",
      errLimit: (limit, n) => `Ton pack autorise ${limit} photos maximum (${n} sélectionnées).`,
      errRetouch: "Décris la retouche souhaitée.",
      errContact: "Renseigne ton nom et un email valide.",
      errSend: "Échec de l'envoi. Réessaie ou écris directement à contact@fight-lens.fr.",
      successTitle: "Commande envoyée.",
      successText: "Ton récapitulatif est arrivé chez Nono. Tu recevras une réponse avec les modalités (et le tarif de retouche le cas échéant) à l'adresse indiquée.",
      successSpam: "Un email de confirmation vient de t'être envoyé — s'il n'apparaît pas, pense à vérifier ton dossier « Indésirables / Spam ».",
      backToSite: "Retour au site",
      lang: "EN",
    },
    nav: {
      work: "Travail",
      services: "Services",
      about: "À propos",
      contact: "Contact",
      shop: "Tarifs",
      order: "Commander",
      hunt: "Chasse QR",
      agenda: "Agenda",
      lang: "EN",
    },
    agenda: {
      eyebrow: "Agenda",
      title: "Prochains",
      title2: "événements.",
      intro: "Galas, championnats et shootings à venir. Les dates accréditées sont confirmées — les autres sont en cours de validation.",
      private: "Shooting Privé",
      status: { accredited: "Accrédité", pending: "En cours", tbc: "À confirmer" },
      types: { boxing: "Boxe", mma: "MMA", bodybuilding: "Culturisme", fashion: "Mode" },
      ctaText: "Un combat, un événement, un portrait ? Réservons ta date.",
      cta: "Réserver un shooting",
    },
    hero: {
      eyebrow: "Photographe — Sports de combat",
      tagline: "La seule défaite,",
      tagline2: "c'est d'abandonner.",
      sub: "Boxe. MMA. Galas. Une vision cinématographique du combat.",
      cta: "Voir le portfolio",
      scroll: "Défiler",
    },
    marquee: ["Boxe", "MMA", "Galas", "Portraits", "Behind the scenes", "Reportages"],
    portfolio: {
      eyebrow: "Portfolio",
      title: "Le combat,",
      title2: "image par image.",
      all: "Tout",
      fight: "Combat",
      portrait: "Portrait",
      bts: "Behind the scenes",
    },
    services: {
      eyebrow: "Services",
      title: "Pour les guerriers.",
      title2: "Pour les marques.",
      cta: "Sur demande",
      items: [
        { n: "01", t: "Couverture d'événement", d: "Soirées combat, galas, championnats. Une narration visuelle complète, de l'entrée du fighter au verdict final." },
        { n: "02", t: "Portraits de combattants", d: "Séances dédiées en studio ou sur les lieux d'entraînement. Identité visuelle forte pour boxeurs, MMA, kick." },
        { n: "03", t: "Contenu réseaux sociaux", d: "Production de contenu calibré pour Instagram, TikTok, YouTube. Posters, teasers, posts cinématographiques." },
        { n: "04", t: "Storytelling visuel", d: "Reportages longs, documentaire, suivi de carrière. Raconter la guerre derrière le sport." },
      ],
    },
    about: {
      eyebrow: "À propos",
      title: "Nono.",
      title2: "Derrière l'objectif.",
      p1: "Alexis Lecoeuvre — alias Nono — est photographe de sports de combat. Boxe, MMA, kick. De la sueur du gym à la lumière du ring.",
      p2: "Sa mission : hisser l'imagerie du combat au niveau des plus grands sports mondiaux. Brute. Cinématographique. Sans filtre.",
      p3: "Chaque image est un round. Chaque round, une histoire.",
    },
    trust: {
      chapter: "Chapitre 05",
      title: "Ils m'ont fait",
      title2: "confiance.",
      intro:
        "Clubs, organisateurs, combattants — ils travaillent avec Nono pour raconter leurs soirées, leurs combats, leurs carrières.",
      taglines: {
        lru: "Club actuel — Lille",
        bcr: "Invitation NoMercy 5",
        bca: "Invité au gala",
        ceintures: "Tournoi International 2026",
        wbc: "Championnat du Monde Youth",
        mbg: "Invitation Championnat du Monde",
      },
      quotes: [
        {
          id: "t1",
          quote:
            "Nono capture ce que les caméras ratent. La sueur, le regard, la seconde avant le KO. Chaque photo est un souvenir gravé.",
          author: "K. Benali",
          role: "Boxeur pro — Welters",
        },
        {
          id: "t2",
          quote:
            "On l'a invité aux Ceintures — il a livré des images qu'on n'avait jamais eues sur nos tournois. Direction artistique impeccable, livraison rapide.",
          author: "Camales",
          role: "Organisateur — MTP Boxing · Les Ceintures",
        },
        {
          id: "t3",
          quote:
            "Depuis que Nono shoote au club, la comm' a changé de dimension. Les gamins se voient comme des champions. C'est ça, l'impact d'une bonne image.",
          author: "Rachid Sali",
          role: "Coach — Lille Ring United",
        },
        {
          id: "t4",
          quote:
            "Alexis est un bon photographe, super sympa, agréable et surtout avec des qualités de photos superbes, de vrais souvenirs pour les jeunes et le club. Toute l'équipe du Metz Boxing Gym est heureuse de collaborer avec toi et ce ne sera pas la dernière fois 🥊",
          author: "Martina Mepas",
          role: "Présidente — Metz Boxing Gym",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's work",
      title2: "together.",
      sub: "Pour une couverture, un portrait, ou une collaboration. Réponse sous 48h.",
      name: "Nom",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer le message",
      sending: "Envoi…",
      success: "Message envoyé. Réponse imminente.",
      error: "Échec de l'envoi. Réessayez ou écrivez directement.",
      direct: "Ou écrivez directement à",
      ig: "Instagram",
    },
    footer: {
      rights: "Tous droits réservés.",
      built: "Photographie & vision",
      tagline: "Boxe · MMA · Galas",
      legalTitle: "Mentions légales",
      legalSiret: "SIRET : 108 579 624 00017",
      legalRegistered:
        "Entreprise enregistrée et reconnue par l'État français.",
    },
  },
  en: {
    order: {
      navTitle: "Order photos",
      site: "Site",
      eyebrow: "Event galleries",
      title: "Order",
      title2: "your photos.",
      intro: "Pick your pack, your event, your fight, then select your photos. No online payment — you get a summary and Nono gets back to you to finalise.",
      stepPack: "Choose your pack",
      stepGala: "Choose your event",
      stepFight: "Choose your fight",
      stepPhotos: "Select your photos",
      stepFinal: "Retouching & checkout",
      fights: (n) => `${n} fight${n > 1 ? "s" : ""}`,
      upcoming: "Coming soon",
      noFights: "Fights from this event will be added soon. Come back later or write to contact@fight-lens.fr.",
      groups: { "Combats amateurs": "Amateur fights", "Combats professionnels": "Professional fights" },
      photosCount: (n) => `${n} photos`,
      photosAvailable: "Photos available",
      galleryPending: "Gallery in progress",
      maxPhotos: (n) => `${n} photos max`,
      viewPhotos: "View photos",
      externalInstructions: "Note down the numbers of the photos you want, then come back here to place your order and specify your selection.",
      noPhotos: "This fight's gallery is being prepared. You can still order your pack — Nono will email you the full gallery so you can make your selection.",
      selected: (n, limit) => `${n}${limit !== null ? ` / ${limit}` : ""} photo${n > 1 ? "s" : ""} selected`,
      limitReached: (pack, limit) => `Limit reached — the ${pack} allows ${limit} photos max. Upgrade your pack to select more.`,
      retouchToggle: "Add a retouching request (quote on request)",
      retouchPlaceholder: "Describe the retouching you want (photos concerned, style, elements to change…)",
      messageLabel: "Message (optional)",
      messagePlaceholder: "Extra requests, details, deadlines…",
      nameLabel: "Your name",
      namePlaceholder: "First name Last name",
      emailLabel: "Your email",
      emailPlaceholder: "example@mail.com",
      retouchNotice: "Retouching and special requests extend the delivery time. The retouching price will be sent to you by email before work begins.",
      submit: "Send my order",
      sending: "Sending…",
      errGalaFight: "Choose an event and a fight.",
      errPack: "Choose a pack.",
      errLimit: (limit, n) => `Your pack allows ${limit} photos max (${n} selected).`,
      errRetouch: "Describe the retouching you want.",
      errContact: "Enter your name and a valid email.",
      errSend: "Sending failed. Try again or write directly to contact@fight-lens.fr.",
      successTitle: "Order sent.",
      successText: "Your summary has reached Nono. You'll receive a reply with the details (and the retouching price if applicable) at the address provided.",
      successSpam: "A confirmation email has just been sent to you — if it doesn't show up, check your Junk / Spam folder.",
      backToSite: "Back to site",
      lang: "FR",
    },
    nav: {
      work: "Work",
      services: "Services",
      about: "About",
      contact: "Contact",
      shop: "Pricing",
      order: "Order photos",
      hunt: "QR Hunt",
      agenda: "Agenda",
      lang: "FR",
    },
    agenda: {
      eyebrow: "Agenda",
      title: "Upcoming",
      title2: "events.",
      intro: "Fight nights, championships and upcoming shoots. Accredited dates are confirmed — the others are pending validation.",
      private: "Private Shoot",
      status: { accredited: "Accredited", pending: "In progress", tbc: "To confirm" },
      types: { boxing: "Boxing", mma: "MMA", bodybuilding: "Bodybuilding", fashion: "Fashion" },
      ctaText: "A fight, an event, a portrait? Let's book your date.",
      cta: "Book a shoot",
    },
    hero: {
      eyebrow: "Photographer — Combat sports",
      tagline: "The only defeat",
      tagline2: "is to quit.",
      sub: "Boxing. MMA. Fight nights. A cinematic vision of combat.",
      cta: "See the portfolio",
      scroll: "Scroll",
    },
    marquee: ["Boxing", "MMA", "Galas", "Portraits", "Behind the scenes", "Reporting"],
    portfolio: {
      eyebrow: "Portfolio",
      title: "Combat,",
      title2: "frame by frame.",
      all: "All",
      fight: "Fight",
      portrait: "Portrait",
      bts: "Behind the scenes",
    },
    services: {
      eyebrow: "Services",
      title: "For the fighters.",
      title2: "For the brands.",
      cta: "On request",
      items: [
        { n: "01", t: "Event coverage", d: "Fight nights, galas, championships. Full visual storytelling — from the walkout to the final verdict." },
        { n: "02", t: "Fighter portraits", d: "Studio or gym sessions. Strong visual identity for boxers, MMA athletes, kickboxers." },
        { n: "03", t: "Social media content", d: "Calibrated content for Instagram, TikTok, YouTube. Posters, teasers, cinematic edits." },
        { n: "04", t: "Visual storytelling", d: "Long-form reporting, documentary, career follow-up. Telling the war behind the sport." },
      ],
    },
    about: {
      eyebrow: "About",
      title: "Nono.",
      title2: "Behind the lens.",
      p1: "Alexis Lecoeuvre — aka Nono — is a combat sports photographer. Boxing, MMA, kick. From the sweat of the gym to the light of the ring.",
      p2: "His mission: bring combat imagery to the level of the biggest global sports. Raw. Cinematic. Unfiltered.",
      p3: "Every frame is a round. Every round, a story.",
    },
    trust: {
      chapter: "Chapter 05",
      title: "They trusted",
      title2: "the lens.",
      intro:
        "Clubs, promoters, fighters — they work with Nono to tell the story of their nights, their fights, their careers.",
      taglines: {
        lru: "Current club — Lille",
        bcr: "NoMercy 5 invitation",
        bca: "Gala guest",
        ceintures: "International Tournament 2026",
        wbc: "Youth World Championship",
        mbg: "World Championship invitation",
      },
      quotes: [
        {
          id: "t1",
          quote:
            "Nono captures what the cameras miss. The sweat, the stare, the second before the KO. Every photo is a memory carved in stone.",
          author: "K. Benali",
          role: "Pro boxer — Welterweight",
        },
        {
          id: "t2",
          quote:
            "We invited him to Les Ceintures — he delivered images we had never had of our tournaments. Flawless art direction, fast delivery.",
          author: "Camales",
          role: "Promoter — MTP Boxing · Les Ceintures",
        },
        {
          id: "t3",
          quote:
            "Since Nono started shooting at the club, our comms have reached another level. The kids see themselves as champions. That's the power of a great image.",
          author: "Rachid Sali",
          role: "Coach — Lille Ring United",
        },
        {
          id: "t4",
          quote:
            "Alexis is a great photographer, super friendly, pleasant and above all delivers superb photos — real memories for the kids and the club. The whole Metz Boxing Gym team is happy to work with you and it won't be the last time 🥊",
          author: "Martina Mepas",
          role: "President — Metz Boxing Gym",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's work",
      title2: "together.",
      sub: "For event coverage, a portrait, or a collaboration. Reply within 48h.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send the message",
      sending: "Sending…",
      success: "Message sent. Reply incoming.",
      error: "Sending failed. Try again or reach out directly.",
      direct: "Or reach out directly at",
      ig: "Instagram",
    },
    footer: {
      rights: "All rights reserved.",
      built: "Photography & vision",
      tagline: "Boxing · MMA · Fight nights",
      legalTitle: "Legal notice",
      legalSiret: "SIRET: 108 579 624 00017",
      legalRegistered:
        "Business registered and recognized by the French State.",
    },
  },
};
